export const formatCurrency = (value) => {
	if (value) return value.toLocaleString('id-ID');
	return;
};